import { TappSidebarItem } from '@/components/ui/TappSidebar';
import { TappUIShell } from '@/components/ui/TappUIShell';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../lib/auth.store';
import { useTranslation } from 'react-i18next';

function AdminLayout() {
  const auth = useAuth();
  const { t } = useTranslation();

  const sidebarItems: TappSidebarItem[] = useMemo(
    () => [
      { name: t('drivers'), icon: 'group', link: '/admin/drivers' },
      { name: t('companies'), icon: 'business', link: '/admin/companies' },
      { name: t('customers'), icon: 'group', link: '/admin/customers' },
      { name: t('rides'), icon: 'local_taxi', link: '/admin/rides' },
      { name: t('support'), icon: 'support_agent', link: '/admin/support' },
      { name: t('logout'), icon: 'logout', position: 'bottom', onClick: () => auth.logout() },
    ],
    []
  );

  return (
    <TappUIShell logoUrl="/logo.png" logoSmallUrl="/logo_small.png" items={sidebarItems}>
      <Outlet />
    </TappUIShell>
  );
}

export default AdminLayout;
